import React, {useEffect, useState} from "react"
import { connect } from "react-redux"
import { FormikProps } from "formik/dist/types";
import {Tooltip} from "@material-ui/core";
import {Button} from "react-bootstrap"
import {ConfigurationsType} from "../../../types/configurations";
import {ShapeType} from "../../../types/shape";
import {allRequiredFieldsHaveBeenFilled} from "../../../helpers/dynamicFormHelper";
import {ProductImageStacType} from "../../../types/product";
import {isInvalidation, isReprocessing, isUpdateResultsSearchAvailable} from "../../../helpers/configurationHelper";
import {DEFAULT_TOOLTIP_PROPS} from "../../../helpers/tooltipHelper";
import {AppParametersType} from "../../../types/app";
import translations from "../../../translations";
import {InvalidationJobType, ReprocessingJobType} from "../../../types/cart";
import {submitJobAction} from "../../../state/cart/dispatchActions";

interface PropsType {
  mainInputConfigurations: any,
  configurations: ConfigurationsType,
  scopeConfigurationFields: string,
  selectedArea: ShapeType,
  selectedProducts: ProductImageStacType[],
  formProps: FormikProps<any>,
  appParameters: AppParametersType,
  searchByProducts: boolean,
  language: string,
  searchResults: any,
  submitJobActionHandler: any,
  searchProductIds: any
}

const SearchButtons = (props: PropsType) => {
  const {
    mainInputConfigurations,
    configurations,
    scopeConfigurationFields,
    selectedArea,
    formProps,
    selectedProducts,
    appParameters,
    searchByProducts,
    language,
    searchResults,
    submitJobActionHandler,
    searchProductIds
  } = props;

  const {
    isSubmitting,
    values
  } = formProps;

  // const isSearchButtonDisabled = isSubmitting ||
  // !allRequiredFieldsHaveBeenFilled(mainInputConfigurations, configurations, scopeConfigurationFields, values, selectedArea, searchByProducts, appParameters) ||
  // (!searchProductIds || searchProductIds.length === 0 || searchProductIds[0] === "");

  const isSearchButtonDisabled = isSubmitting ||
  (!searchByProducts && !allRequiredFieldsHaveBeenFilled(mainInputConfigurations, configurations, scopeConfigurationFields, values, selectedArea, searchByProducts, appParameters)) ||
  (searchByProducts && (!searchProductIds || searchProductIds.length === 0 || searchProductIds[0] === ""));
 
  let updateResultsButton = <div />;
  if (isUpdateResultsSearchAvailable(configurations, appParameters, values, selectedProducts)) {
    updateResultsButton = (
      <Button
        id="update-search-button"
        className="btn secondary-search-btn search-btn ml-3"
        disabled={isSearchButtonDisabled}
        style={isSearchButtonDisabled ? {pointerEvents: "none"} : {}}
        type="submit"
      >
        {translations("updateSearch", appParameters.language)}
      </Button>
    );

    if (!isSubmitting) {
      updateResultsButton = (
        <Tooltip
          {...DEFAULT_TOOLTIP_PROPS}
          title={(isSearchButtonDisabled && translations("fillAllSearch", appParameters.language)) || translations("refineSearch", appParameters.language)}
          placement="top"
        >
          <span>{updateResultsButton}</span>
        </Tooltip>
      )
    }
  }
  let searchButton = (
    <Button
      className="btn search-btn ml-3"
      disabled={isSearchButtonDisabled || isUpdateResultsSearchAvailable(configurations, appParameters, values, selectedProducts)}
      style={isSearchButtonDisabled || isUpdateResultsSearchAvailable(configurations, appParameters, values, selectedProducts) ? {pointerEvents: "none"} : {}}
      type="submit"
    >
      {translations("searchSearch", appParameters.language)}
    </Button>
  );

  const [isProceedingInvalidation, setIsProceedingInvalidation] = useState(false);
  const [isProceedingReprocessing, setIsProceedingReprocessing] = useState(false);
  const invalidateButtonHandler = () => {
    setIsProceedingInvalidation(true);
    const newJob: InvalidationJobType = {
      arguments: {
        validate: invalidate_mode
      },
      item_list: searchResults.items.map((item) => item.id),
      process_id: "Validate",
    };
    submitJobActionHandler(
      window,
      appParameters,
      newJob
    ).then((submitJobResult) => {
      const { valid } = submitJobResult;
      if (valid.length > 0) {
        formProps.resetForm();
      }
    }).finally(() => {
      setIsProceedingInvalidation(false);
    });
  }

  const reprocessButtonHandler = () => {
    setIsProceedingReprocessing(true);
    const newJob: ReprocessingJobType = {
      item_list: searchResults.items.map((item) => item.id),
      process_id: "Reprocessing",
    };
    submitJobActionHandler(
      window,
      appParameters,
      newJob
    ).then((submitJobResult) => {
      const { valid } = submitJobResult;
      if (valid.length > 0) {
        formProps.resetForm();
      }
    }).finally(() => {
      setIsProceedingReprocessing(false);
    });
  }

  const {invalidate_mode} = formProps.values;

  const [hasInvalidationResults, setHasInvalidationResults] = useState(false);
  const [hasReprocessingResults, setHasReprocessingResults] = useState(false);

  useEffect(() => {
    if (isInvalidation(configurations, appParameters)) {
      const newHasInvalidationResults = !!(searchResults && searchResults.items && searchResults.items.length);
      setHasInvalidationResults(newHasInvalidationResults);
    }
    if (isReprocessing(configurations, appParameters)) {
      const newHasReprocessingResults = !!(searchResults && searchResults.items && searchResults.items.length);
      setHasReprocessingResults(newHasReprocessingResults);
    }
  }, [searchResults]);

  const [invalidationButtonText, setInvalidationButtonText] = useState("");

  const invalidateButton = (
    <Button className="btn search-btn ml-3" type="button" onClick={() => invalidateButtonHandler()} disabled={isProceedingInvalidation || !hasInvalidationResults}>{invalidationButtonText}</Button>
  )

  const reprocessButton = (
    <Button className="btn search-btn ml-3" type="button" onClick={() => reprocessButtonHandler()} disabled={isProceedingReprocessing || !hasReprocessingResults}>{translations("reprocess", language)}</Button>
  )

  useEffect(() => {
    setInvalidationButtonText(translations(formProps.values.invalidate_mode ? "invalidate" : "validate", language));
  }, [formProps.values.invalidate_mode, invalidate_mode, language]);

  if (!isSubmitting) {
    searchButton = (
      <Tooltip
        {...DEFAULT_TOOLTIP_PROPS}
        title={isUpdateResultsSearchAvailable(configurations, appParameters, values, selectedProducts)
          ? translations("deselectToPerformSearch", appParameters.language)
          : (isSearchButtonDisabled && translations("fillAllSearch", appParameters.language)) || translations("clickToPerformSearch", appParameters.language)}
        placement="top"
      >
        <span>
          {searchButton}
        </span>
      </Tooltip>
    )
  }
  return (
    <div className="buttons px-3 py-4">
      { updateResultsButton }
      { searchButton }
      { isInvalidation(configurations, appParameters) && invalidateButton }
      { isReprocessing(configurations, appParameters) && reprocessButton }
    </div>
  )
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  submitJobActionHandler: (win, appParameters, job) => dispatch(submitJobAction(win, appParameters, job))
});

const mapStateToProps = (state) => ({
  searchByProducts: state.geoMap.searchByProducts,
  searchResults: state.product.searchResults,
  language: state.application.appParameters.language,
  searchProductIds: state.geoMap.searchProductIds
})

export default connect(mapStateToProps, mapDispatchToProps)(SearchButtons)
